// components/auth/PrivateRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useSession } from "../../session/SessionProvider";

const PrivateRoute = ({ children }) => {
  const { loading, user } = useSession();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-gray-500 text-sm animate-pulse">
          در حال بررسی اطلاعات...
        </div>
      </div>
    );
  }

  if (!user?.token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
